export const getAbsoluteUrl = (relativePath: string) => `${window.location.origin}${relativePath}`
